import { makeLogger } from '@/services/utils/logger';
import { LOGGING } from '@/config';
const DEBUG_LOG = false;
const log = makeLogger('Player', DEBUG_LOG, LOGGING.MODELS_LOG);

export default class Player {
  /**
   * Создает нового игрока.
   * @param {string} name - Имя игрока.
   */
  constructor(name, clubId) {
    this.id = null;//Player.#generateId();
    this.clubId = clubId ? Array.isArray(clubId) ? clubId : [clubId] : [];
    this.name = name;
    this.createdAt = new Date().toISOString();
    this.updatedAt = new Date().toISOString();
    this.ratingsMap = null;
    this.title = null;
    this.labels = [];
    this.categories = [];
  }

  /**
   * Создает экземпляр Player из объекта.
   * @param {Object} obj - Объект с данными игрока.
   * @param {string} obj.name - Имя игрока.
   * @param {string} obj.id - Уникальный идентификатор игрока.
   * @param {string} obj.createdAt - Дата создания в ISO формате.
   * @returns {Player} Экземпляр Player.
   */
  static fromObject(obj) {
    log('fromObject', '👤 Входные данные:', obj);
    const player = new Player(obj.name || '', obj.clubId || []);
    player.id = obj.id || null;
    if (obj.firstName !== undefined) player.firstName = obj.firstName;
    if (obj.lastName !== undefined) player.lastName = obj.lastName;
    player.createdAt = obj.createdAt || new Date().toISOString();
    player.updatedAt = obj.updatedAt || player.createdAt;
    if (obj.ratingsMap) {
      player.ratingsMap = obj.ratingsMap;
    }
    player.title = obj.title || null;
    player.labels = Array.isArray(obj.labels) ? obj.labels : [];
    player.categories = Array.isArray(obj.categories) ? obj.categories : [];
    log('fromObject', '✅ Результат:', player);
    return player;
  }

  /**
   * Возвращает рейтинговую информацию игрока для указанного контроля.
   * @param {string|null} controlType
   * @returns {{controlType: string|null, rating: number|null, provisional: boolean, source: string}}
   */
  getRatingInfo(controlType = null) {
    const ratingEntry = controlType ? this.ratingsMap?.[controlType] : null;
    const rating = typeof ratingEntry?.rating === 'number' ? ratingEntry.rating : null;

    return {
      controlType,
      rating,
      provisional: Boolean(ratingEntry?.provisional),
      source: 'player',
    };
  }

  /**
   * Возвращает метаданные звания игрока для указанного клуба.
   * @param {string|null} [clubId=null]
   * @returns {{code: string, name: string, scope: string, className: string}|null}
   */
  getTitleMeta(clubId = null) {
    const title = Array.isArray(this.title)
      ? (
          this.title.find((item) => item?.scope === 'fide') ||
          (clubId ? this.title.find((item) => item?.chess_club === clubId) : null) ||
          null
        )
      : this.title;
    const code = String(title?.code || '').trim();
    if (!title || !code) return null;
    if (title.scope !== 'fide' && (!clubId || (title.chess_club && title.chess_club !== clubId))) return null;

    return {
      code,
      name: String(title?.name || code).trim(),
      scope: title?.scope === 'fide' ? 'fide' : 'local',
      className: title?.scope === 'fide' ? 'utitle--fide' : 'utitle--local',
    };
  }

  /**
   * Возвращает имя игрока с префиксом звания, если оно есть.
   * @param {string|null} [clubId=null]
   * @returns {string}
   */
  getDisplayName(clubId = null) {
    const name = String(this.name || '').trim();
    const titleMeta = this.getTitleMeta(clubId);
    if (!titleMeta) return name;
    return `${titleMeta.code} ${name}`.trim();
  }
}
